<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div align="center">
      <h2 class="mt-4 mb-4 text-color font-size-25 font-weight-500 letter-spacing">
        SEARCH DOCTOR
      </h2>
    </div>
    <div class="row justify-content-center">
      <div class="col-lg-10">
        <form [formGroup]="searchForm">
          <div class="row">
            <div class="col-md-3 mt-2 mt-md-0">
              <input class="form-control" type="text" placeholder="Doctor's Name" formControlName="name" />
            </div>
            <div class="col-md-3 mt-2 mt-md-0">
              <select class="form-control" formControlName="speciality">
                <option value="0">Select Speciality</option>
                <option *ngFor="let speciality of specialitiesList" [value]="speciality.id">
                  {{ speciality.name }}
                </option>
              </select>
            </div>

            <div class="col-md-3 mt-2  mt-md-0">
              <input class="form-control" type="text" placeholder="City" formControlName="city" />
            </div>

            <div class="col-md-3 mt-2 mt-md-0">
              <button type="submit" class="btn btn-primary btn-lg pl-5 pr-5 w-100" (click)="searchDoctor(1)">
                SEARCH
              </button>
            </div>
          </div>

          <br />
          <div class="text-dark text-center font-weight-900 font-weight-bold">Additional filters for Symptoms and
            Availability</div>
          <div align=" center">
            <span style="cursor: pointer;">
              <div (click)="panel_expa = !panel_expa;  this.tmpl_expa = false; resetForm('all');
              ">
                <h2 class="mt-2 text-color font-size-25 font-weight-500 letter-spacing">
                  FIND BY SYMPTOMS OR AVAILABILITY&nbsp;<span class="mdi mdi-arrow-down-drop-circle-outline"></span>
                </h2>
              </div>
            </span>
          </div>
          <br /><br />
          <div class="row" *ngIf="panel_expa">
            <div class="row col-sm-6" align="center">
              <span *ngIf="!panel_expa1" class="mt-2 mb-4 text-color font-size-18 font-weight-500 letter-spacing">
                <div class="ml-3"><span class="mdi mdi-pill" style="color:green"></span>
                  &nbsp;Find by Symptoms / Illness
                </div>
              </span>

              <div class="row  pl-5">
                <div class="col-md-12  mt-3">
                  <angular2-multiselect class="form-control" [data]=" illness_list" [(ngModel)]="selectedItems"
                    [settings]="dropdownSettings" formControlName="illness" (onSelect)="onItemSelect($event)"
                    (onDeSelect)="OnItemDeSelect($event)" (onSelectAll)="onSelectAll($event)"
                    (onDeSelectAll)="onDeSelectAll($event)">
                  </angular2-multiselect>
                </div>
              </div>
            </div>

            <div class="row  col-sm-6" align="center">
              <span class="mt-2 mb-4 text-color font-size-18 font-weight-500 letter-spacing">
                <div class="ml-3"><span class="mdi mdi-calendar-clock" style="color:green"></span>
                  &nbsp;Find by Date & Time
                </div>
              </span>

              <div class="row pl-5">
                <div class="col md-6 sm-12 mt-5 ">
                  <div class="d-flex ">
                    <input class="form-control" placeholder="Date(DD/MM/YYYY)" name="date" formControlName="date"
                      ngbDatepicker #ed="ngbDatepicker" data-date-inline-picker="false" id="date"
                      [minDate]=" currentDate" />
                    <div>
                      <button class="btn btn-outline-secondary calendar rounded-0" (click)="ed.toggle()" type="button"
                        style="line-height: 2.5;" id="endDateButton">
                        <span class="fa fa-calendar"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div class="col md-6 mt-2 sm-12 d-flex align-items-center justify-content-center">
                  <ngb-timepicker formControlName="time" meridian=true>
                  </ngb-timepicker>
                </div>

              </div>
            </div>

            <div class="row">
              <div class="col-md-4 col-lg-4"></div>
              <div class="col-md-4 lg-4 pt-3">
                <button type="submit" class="btn btn-primary btn-lg pl-5 pr-5 w-100" (click)="searchDoctor(1)">
                  SEARCH
                </button>
              </div>
              <div class="col-md-4 lg-4"></div>
            </div>

          </div>








        </form>
        <div class="row mt-5" *ngIf="physicians?.length">
          <div class="col-md-6" *ngFor="let physician of physicians">
            <div class="card m-b-30">
              <div class="card-body">
                <div class="row">
                  <div class="col-lg-4 ">
                    <div class="card m-b-30 border-0">
                      <div class=" d-flex">
                        <img [src]="physician?.ppurl" class="imgcenter wh-110px" />
                      </div>
                      <div class="pt-2 float-end" *ngIf="physician?.verified">
                        <i class="fa fa-check-square checkbox-color"></i>
                        <span class="text-gray font-weight-italic font-size-14 ml-2">Verified</span>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-8 detail-tbl h-200px">
                    <div class="d-flex">
                      <h3 class="text-color col-12 font-size-17 font-weight-500 pl-0 pr-0 text-capitalize">
                        {{ physician?.title ? physician?.title : defaultDr }}
                        {{ physician?.first_name }}
                        {{ physician?.last_name }}
                        <span class="text-gray font-weight-italic font-size-14 ml-2">
                          {{ physician?.qualification}}
                        </span>
                      </h3>
                      <!-- <div class="col-lg-6"> -->
                      <!-- <div class="mb-auto col-4 pl-0 pr-0" *ngIf="physician?.verified">
                        <i class="fa fa-check-square checkbox-color"></i>
                        <span class="text-gray font-weight-italic font-size-14 ml-2">Verified</span>
                      </div> -->
                      <!-- </div> -->
                    </div>

                    <div class="row pt-2">
                      <div class="col-12 d-flex">
                        <div class="">
                          <p *ngIf="physician.physician_speciality" class="text-change font-size-15 font-weight-400">
                            {{physician?.physician_speciality | slice:0:41 }}
                            <ng-container #id *ngIf="physician.show">
                              {{physician?.physician_speciality | slice:41:82 }}
                            </ng-container>
                            <a *ngIf="physician.physician_speciality.length>40" (click)="toggle(physician)" id="bt">
                              ...
                            </a>

                          </p>
                          <!-- <p class="text-change font-size-15 font-weight-400">
                            {{ physician?.physician_speciality }}
                          </p> -->
                          <!-- <p *ngIf="
                              physician.physician_qualification &&
                              physician.physician_qualification[0].r_no
                            ">
                            Reg No.{{
                            physician?.physician_qualification[0].r_no
                            }}
                          </p> -->
                        </div>
                        <!-- <div class="col-lg-6">
                            <div class="mb-auto" *ngIf="physician?.verified">
                              <i class="fa fa-check-square checkbox-color ml-2"></i>
                              <span class="text-gray font-weight-italic font-size-14 ml-2 ">Verified</span>
                            </div>
                          </div> -->
                      </div>
                    </div>
                    <div class="rating-color rating-wrap cursor mb-3">
                      <ngb-rating style="font-size: 1.5rem" class="bi-star-fill" [max]="5"
                        [rate]="physician?.ratings?.total_rating" [readonly]="true">
                      </ngb-rating>
                      <!-- {{physician?.ratings?.total_count}} -->
                      <span class="ml-2 text-gray">{{
                        physician?.ratings?.total_count?physician?.ratings?.total_count+' Ratings - ':''
                        }}
                      </span>
                      <span (click)="showfeedback($event,physician)" id="showFeedback" class="ml-2 text-gray">
                        {{
                        physician?.ratings?.total_count?'Read Reviews':''
                        }}
                      </span>
                    </div>
                    <div class="font-size-20 d-flex text-gray text-capitalize" *ngIf="physician?.location">
                      <i class="fa fa-map-marker"></i>
                      <p class="ml-2 text-gray">{{ physician?.location }}</p>
                    </div>

                    <div class="font-size-20 d-flex text-gray text-capitalize" *ngIf="physician?.contact_no2">
                      <p><i class="fa fa-mobile"></i>
                        {{ physician?.contact_no2 }}</p>
                    </div>
                    <div class="font-size-20 d-flex text-gray text-capitalize" *ngIf="physician?.email_id2">
                      <p><i class="fa fa-envelope fa-2xs"></i>
                        {{ physician?.email_id2 }}</p>
                    </div>


                    <!-- <div class="d-flex text-gray text-capitalize" *ngIf="physician?.contact_no2">
                      <p *ngIf="physician?.contact_no2" class="text-gray"><i class="fa fa-mobile fa-2x"></i> {{
                        physician?.contact_no2 }}

                      <p *ngIf="physician?.email_id2" class="text-gray"> <i class="fa fa-envelope fa-1x"></i> {{
                        physician?.email_id2 }}</p>
                    </div> -->
                  </div>
                  <!-- <div class="col-lg-3">
                      <div class="d-flex flex-column">
                        <div class="mb-auto">
                          <a *ngIf="physician?.consult_now"
                            class="btn bg-green button-color text-success btn-rounded btn-xs pl-4 pr-4 ml-auto mb-3">Online</a>
                        </div>
                        <div class="mb-auto" *ngIf="physician?.verified">
                          <i class="fa fa-check-square checkbox-color ml-2"></i>
                          <span class="text-gray font-weight-italic font-size-14 ml-2 ">Verified</span>
                        </div>
                      </div>
                    </div> -->
                  <!-- </div> -->
                </div>
                <hr />
                <div class="row justify-content-center margin">
                  <button type="button" class=" btn btn-primary w-50 bg-white font-size-15 font-weight-500 text-color"
                    (click)="scheduleRequest(physician)">
                    SCHEDULE NOW
                  </button>
                  <!-- ============= Commented for later use ========== -->
                  <!-- <div class="vl"></div>
                  <button type="button" class="btn w-50 bg-white text-color font-size-15 font-weight-500">CONSULT
                    NOW</button> -->
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row col" *ngIf="physicians?.length">
          <div class="d-flex">
            <div class="form-group d-flex mb-0 mr-2">
              <select class="pagination form-control" [(ngModel)]="pagesize" id="pagesize" (change)="pageChanged()">
                <option *ngFor="let c of pageCount" value="{{ c }}">
                  {{ c }}
                </option>
              </select>
            </div>
            <ngb-pagination [collectionSize]="collectionSize" [(page)]="page" [maxSize]="5" [pageSize]="pagesize"
              [rotate]="true" [boundaryLinks]="true" (pageChange)="pageChanged()"></ngb-pagination>
            <div class="ml-2 line-h-36">Total rows : {{ collectionSize }}</div>
          </div>
        </div>

        <div class="row mt-5" *ngIf="!physicians?.length && noPhysician">
          <div class="col-lg-12 mt-2 text-center">
            <h5 class="text-danger">NO PHYSICIAN FOUND</h5>
          </div>
        </div>
      </div>
    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>

<!-- //modal -->
<ng-template #scheduleRequestModal let-modal>
  <div class="modal-body p-4">
    <br /><br />
    <div class="row">
      <div class="col-md-6">
        <label class="font-size-18 font-weight-500 mt-3">SELECT MEMBER</label>
      </div>
      <div class="col-md-6">
        <select class="form-control" (change)="selectMember($event.target.value)">
          <option *ngFor="let m of totalMembers" [value]="m?.pid">
            {{ m?.first_name }} {{ m?.last_name }}
          </option>
        </select>
      </div>
    </div>
    <br /><br /><br />
    <div class="text-center">
      <button type="button" class="btn btn-primary btn-sm pl-3 pr-3 pl-md-4 pr-md-4 rounded-0 w-100px"
        (click)="gotoPage()">
        Confirm
      </button>
    </div>
  </div>
</ng-template>
<ng-template #showfeedbackModal let-modal>
  <div class="container-fluid ">


    <div style="text-align:right;"> <br /><a href="javascript:void(0);" class="fa fa-close" (click)="modal.dismiss()"
        style="font-size:18px;color:red;"></a></div>
    <div class="bottomForm">
      <div class="row">
        <div class="col-sm-12">
          <h6 class="heading_color bottomTitle">
            FEEDBACKS
          </h6>
          <div class="row mt-5">
            <div class="col-md-12">
              <div class="card m-b-30">
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-4 text-center">

                      <h5 class="">
                        Ratings & Reviews
                      </h5>
                      <div class=" m-b-30"></div>
                      <h3 class="text-center">
                        {{average_rating | number: '1.1-1' }} <span style="font-size: 1.0rem"><i
                            class="fas fa-star"></i></span>
                      </h3>
                      <div class=" m-b-30"></div>
                      <span class="text-center">{{totalstar_count}}</span>
                      <div class=" m-b-10"></div>
                      <span class="text-center">Ratings & Reviews</span>
                    </div>
                    <div class="col-lg-8">
                      <div class="">
                        <span style="font-size: 1.5rem" class="">5</span>&nbsp;
                        <span style="font-size: 0.8rem"><i class="fas fa-star"></i></span>&nbsp;&nbsp;
                        <progress style="font-size:25px;accent-color:rgb(136, 255, 0); color:rgb(49, 78, 16);"
                          value="{{totalstar_count}}" max="{{totalstar_count}}"></progress>&nbsp;
                        <span>({{fivestar_count}})</span>
                      </div>
                      <div class="">
                        <span style="font-size: 1.5rem" class="">4</span>&nbsp;
                        <span style="font-size: 0.8rem"><i class="fas fa-star"></i></span>&nbsp;&nbsp;
                        <progress style="  font-size:25px ; accent-color :rgb(190, 238, 117) ;color:rgb(46, 238, 28);"
                          value="{{fourstar_count}}" max="{{totalstar_count}}"></progress>&nbsp;
                        <span>({{fourstar_count}})</span>
                      </div>
                      <div class="">
                        <span style="font-size: 1.5rem" class="">3</span>&nbsp;
                        <span style="font-size: 0.8rem"><i class="fas fa-star"></i></span>&nbsp;&nbsp;
                        <progress style="font-size:25px;accent-color:yellow;color:rgb(233, 176, 21);"
                          value="{{threestar_count}}" max="{{totalstar_count}}"></progress>&nbsp;
                        <span>({{threestar_count}})</span>
                      </div>
                      <div class="">
                        <span style="font-size: 1.5rem" class="">2</span>&nbsp;
                        <span style="font-size: 0.8rem"><i class="fas fa-star"></i></span>&nbsp;&nbsp;
                        <progress style="font-size:25px;accent-color:orange;color:rgb(231, 104, 30);"
                          value="{{twostar_count}}" max="{{totalstar_count}}"></progress>&nbsp;
                        <span>({{twostar_count}})</span>
                      </div>
                      <div class="">
                        <span style="font-size: 1.5rem" class="">1</span>&nbsp;
                        <span style="font-size: 0.8rem"><i class="fas fa-star"></i></span>&nbsp;&nbsp;
                        <progress style="font-size:25px;accent-color:rgb(255, 89, 89); color:lightcoral;"
                          value="{{onestar_count}}" max="{{totalstar_count}}"></progress>&nbsp;
                        <span>({{onestar_count}})</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Working Feedback Code - vinoth -->

          <div class="card-body-1 table-responsive">

            <div class="">
              <div id="datatable2_wrapper" class="dataTables_wrapper container-fluid dt-bootstrap4 no-footer">
                <div class="row">
                  <div class="col-sm-12">
                    <table id="datatable2" class="table dataTable no-footer" role="grid"
                      aria-describedby="datatable2_info">
                      <tbody>
                        <div class="row mt-5" *ngIf="!feedback?.length">
                          <div class="col-lg-12 mt-2 text-center">
                            <h5 class="text-danger text-center">NO FEEDBACK RECORDS</h5>
                          </div>
                        </div>
                        <tr role="row" class="odd" *ngFor="let record of feedback">
                          <td>
                            <div class="wh-110px">
                              <img src="https://content-dev.reliabledrs.com/img_avatar.png" alt="avatar"
                                class="w-100 h-100" />
                            </div>
                          </td>
                          <td>{{record.first_name}}
                            <br /><br />
                            <ngb-rating style="font-size: 1.5rem" class="bi-star-fill" [max]="5" [rate]="record?.rating"
                              [readonly]="true">
                            </ngb-rating><br /><br />
                            {{record.apdate | date: 'dd/MM/yyyy'}}

                          </td>
                          <td>{{record.comments}}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Working Feedback Code - vinoth -->

        </div>
      </div>
    </div>
  </div>
</ng-template>